
import { defineComponent } from 'vue'
import { useAxiosRecord } from '@/axios/index.ts'
import { isValid } from '@/classes/ChekType.ts'
export default defineComponent({
  name: 'Point',
  props: {
    groupId: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const { state: recordState } = useAxiosRecord(1, props.groupId)

    return {
      recordState,
      isValid
    }
  }
})
